import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input } from '@angular/core';
import { of } from 'rxjs';
import * as i1 from '@rogers/self-serve-common/page-content';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
function ContentComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "span", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.containerClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx, i0.ɵɵsanitizeHtml);
  }
}
let ContentComponent = /*#__PURE__*/(() => {
  class ContentComponent {
    constructor(pageContent) {
      this.pageContent = pageContent;
      this.province = '';
    }
    ngOnInit() {
      this.getContent$();
    }
    ngOnChanges(changes) {
      if (changes.language || changes.key || changes.context || changes.province) {
        this.getContent$();
      }
    }
    getContent$() {
      this.content$ = this.page ? this.pageContent.getMessages$(this.page, this.language, this.province).pipe(map(messages => messages?.find(message => message.key === this.key && (!this.context || this.context === message.context))?.value || '')) : of('');
    }
    static {
      this.ɵfac = function ContentComponent_Factory(t) {
        return new (t || ContentComponent)(i0.ɵɵdirectiveInject(i1.PageContentFacadeService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContentComponent,
        selectors: [["ss-content"]],
        inputs: {
          context: "context",
          key: "key",
          language: "language",
          province: "province",
          page: "page",
          containerClass: "containerClass"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 3,
        consts: [[3, "class"], [3, "innerHTML"]],
        template: function ContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ContentComponent_Conditional_0_Template, 2, 4, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional(0, (tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.content$)) ? 0 : -1, tmp_0_0);
          }
        },
        dependencies: [AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return ContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ContentComponent };
